module.exports = __webpack_public_path__ + "img/gl_get.ff41cc2.png";